<template>
  <div id="el-header">
    <div class="el-sub-head">
      <div class="el-head-logo">
        <img class="jzLogo" src="../../../static/images/jzlogo.png" alt="嘉智logo">
        <span>
          运踪信息查询平台
        </span>
        <strong>
          <!-- <i>客服热线：</i>
          <em>0532-89012166</em> -->
          <!-- <img :src="telImg" /> -->
        </strong>
      </div>
      <div class="el-head-menu">
        <el-menu
          :default-active="this.$route.path"
          active-text-color="#409eff"
          class="el-menu-navbarTop"
          mode="horizontal"
          @select="handleSelect"
          router>
          <el-menu-item index="/">网站首页</el-menu-item>
          <el-menu-item index="/main">运踪查询</el-menu-item>
          <!-- <el-submenu index="/main">
            <template slot="title">运踪查询</template>
            <el-menu-item index="main">铁路运踪</el-menu-item>
            <el-menu-item index="/mainairport">空运查询</el-menu-item>
          </el-submenu> -->
          <el-submenu index="/product">
            <template slot="title">产品中心</template>
            <el-menu-item index="/product">LK208_旗舰版</el-menu-item>
            <el-menu-item index="/product1">LK900_加强版</el-menu-item>
          </el-submenu>
          <!-- <el-menu-item index="/login" v-if="!falg">登录</el-menu-item> -->

          <el-submenu index="4" v-if="falg">
            <template slot="title">
              <div class="el-user-img" v-if="falg">
                <img :src="userImg" alt="" />
                <span>{{ userName }}</span>
              </div>
            </template>
            <el-menu-item index="/Boxnumber">
              <i class="el-icon-folder-opened"></i>
              综合信息
            </el-menu-item>
            <el-menu-item @click="clearToken">
              <i class="el-icon-switch-button"></i>
              注销登录
            </el-menu-item>
          </el-submenu>
          <el-submenu index="5">
            <template slot="title">
              <i class="el-icon-s-order"></i>
              语言选择
            </template>
            <el-menu-item>
              <a href="http://gps.jagich.com/#/">
                <i class="el-icon-tickets"></i>
                简体中文
              </a>
            </el-menu-item>
            <el-menu-item>
              <a href="http://gps.jagich.com/yz-en/#/">
                <i class="el-icon-tickets"></i>
                English
              </a>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      logo: "",
      logoImg: "",
      // telImg: "./static/images/tel2.png",
      activeIndex: "1",
      userImg: "./static/images/1.png",
      userName: "已登录",
      falg: false,
    };
  },
  mounted() {
    this.getToken();
  },
  methods: {
    getToken() {
      if (localStorage.token != "" && localStorage.token != null) {
        this.falg = !this.falg;
      }
    },
    clearToken() {
      localStorage.removeItem("token");
      this.falg = false;
      //弹出返回信息
      this.$message({
        message: "注销成功",
        type: "success",
        offset: 150,
      });
      this.$router.push("/login");
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
  },
  computed: {},
};
</script>

<style>
  .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
  .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    background-color: transparent !important;
  }

  .el-menu--horizontal>.el-submenu:focus .el-submenu__title,
  .el-menu--horizontal>.el-submenu:hover .el-submenu__title {
    color: #409EFF !important;
  }

  .el-menu--horizontal>.el-submenu .el-submenu__title {
    color: #fff !important;
    height: 52px !important;
    line-height: 52px !important;
  }

</style>

<style scoped>
@import "./comp/header.css";
@import "../../../static/font/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/global/header.vue